export default {
    title: 'Edit title and description',
    tooltip: 'Do not edit title and description anymore',
    form: {
        description: {
            label: 'Description'
        },
        title: {
            label: 'Titel',
            required: 'Please enter the title'
        }
    },
    button: {
        reset: 'Cancel',
        submit: 'Save'
    }
}
